import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { SecurityDomPipe } from 'src/app/pipes/security-dom.pipe';
import { OnlyIntegerDirective } from 'src/app/directives/only-integer';
import { ClientCodeDirective } from 'src/app/directives/client-code';

@NgModule({
  declarations: [SecurityDomPipe, OnlyIntegerDirective, ClientCodeDirective],
  imports: [
    CommonModule,
    MatStepperModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MaterialFileInputModule,
    RxReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatDialogModule,
    HttpClientModule
  ], exports: [
    CommonModule,
    MatStepperModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MaterialFileInputModule,
    RxReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatDialogModule,
    HttpClientModule,
    SecurityDomPipe,
    OnlyIntegerDirective,
    ClientCodeDirective
  ]
})
export class SharedModule { }
